// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRiskToleranceModelResponseDto
 */
export interface IRiskToleranceModelResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IRiskToleranceModelResponseDto
     */
    investor_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRiskToleranceModelResponseDto
     */
    risk_tolerance_model?: IRiskToleranceModelResponseDtoRiskToleranceModelEnum;
}

/**
* @export
* @enum {string}
*/
export enum IRiskToleranceModelResponseDtoRiskToleranceModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}


/**
 * Check if a given object implements the IRiskToleranceModelResponseDto interface.
 */
export function instanceOfIRiskToleranceModelResponseDto(value: object): value is IRiskToleranceModelResponseDto {
    return true;
}

export function IRiskToleranceModelResponseDtoFromJSON(json: any): IRiskToleranceModelResponseDto {
    return IRiskToleranceModelResponseDtoFromJSONTyped(json, false);
}

export function IRiskToleranceModelResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRiskToleranceModelResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investor_id': json['investor_id'] == null ? undefined : json['investor_id'],
        'risk_tolerance_model': json['risk_tolerance_model'] == null ? undefined : json['risk_tolerance_model'],
    };
}

export function IRiskToleranceModelResponseDtoToJSON(json: any): IRiskToleranceModelResponseDto {
    return IRiskToleranceModelResponseDtoToJSONTyped(json, false);
}

export function IRiskToleranceModelResponseDtoToJSONTyped(value?: IRiskToleranceModelResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investor_id': value['investor_id'],
        'risk_tolerance_model': value['risk_tolerance_model'],
    };
}

